'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var TableRow = _interopDefault(require('@material-ui/core/TableRow'));
var styledComponents = require('./styled-components.js');

var renderComponentByType = function (hover, rowCell) {
    if (typeof rowCell === 'function') {
        return rowCell(hover);
    }
    return rowCell;
};
var Row = function (props) {
    var rowId = props.rowId, rowCells = props.rowCells, hasmaxwidth = props.hasmaxwidth, hoverable = props.hoverable, _a = props.clickable, clickable = _a === void 0 ? false : _a, _b = props.isActive, isActive = _b === void 0 ? false : _b, _c = props.colSpan, colSpan = _c === void 0 ? [] : _c, _d = props.onClick, onClick = _d === void 0 ? function () { return undefined; } : _d;
    var _e = React.useState(false), hover = _e[0], setHover = _e[1];
    var hoverOn = function () {
        if (hoverable) {
            setHover(true);
        }
    };
    var hoverOff = function () {
        if (hoverable) {
            setHover(false);
        }
    };
    var theme = core.useTheme();
    var style = {};
    if (hover || isActive) {
        style.backgroundColor = theme.palette.background.default || '#F6F8FC';
    }
    if (clickable) {
        style.cursor = 'pointer';
    }
    return (React__default.createElement(TableRow, { "data-testid": 'body-row', onMouseEnter: hoverOn, onMouseLeave: hoverOff, style: style }, rowCells.map(function (rowCell, index) { return (React__default.createElement(styledComponents.StyledCell
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: rowId + "_" + index, hasmaxwidth: (!!hasmaxwidth).toString(), colSpan: colSpan[index] || 1, onClick: function () { return onClick(); } }, renderComponentByType(hover, rowCell))); })));
};
Row.defaultProps = {
    hasmaxwidth: false,
};

module.exports = Row;
